<div class="modal fade" id="passphraseModalloginModal" role="dialog" aria-labelledby="passphraseModalloginModal" [ngStyle]="{'display': this.universalService.show2FApopUp ? 'block' : 'none', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header border-0">
        @if(!universalService.iframeLogin){
          <div class="login-close-btn-cont" (click)="logOutUser()">
            <span class="NeueFile_Cancel"></span>
          </div>
        }
        <!-- Logo -->
        <div class="logo pt-5 pb-0 pb-md-5">
        <h1>Passphrase</h1>
      </div>
    </div>
    <!-- Modal body -->
    <div class="modal-body border-0">
      <div class="passphrase-input">
        <input #Passphrase type="password" id="passPhraseInput" autofocus class="text-center" minlength="6" maxlength="20" placeholder="Enter your passphrase" (keydown.enter)="validate2FA(Passphrase.value)" (input)="validatePassPharse(Passphrase)"
          (click)="focusOnInputField()" (keyup)="focusOnInputField()" onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false" autocomplete=off/>
        <button (click)="showHidePaasword()" aria-label="Password toggle button" class="eyeBtn" [disabled]="Passphrase.value == ''">
          @if (!show) {
            <i class="NeuePassword-Show" title="Show Passphrase" aria-hidden="true"></i>
          }
          @if (show) {
            <i class="NeuePassword-Hide" title="Hide Passphrase" aria-hidden="true"></i>
          }
        </button>
        <!-- Error -->
        @if (this.implRef.isPassPhraseLoginError  && this.implRef.invalidPassPhraseCounter != 1) {
          <div class="error-msg">
            @if (this.implRef.invalidPassPhraseCounter != 0 && this.implRef.isPassPhraseLoginError != '' && implRef.exception.errorMessage != '') {
              <p class="passPhraseErrorCont"><em class="NeueAlert mr-1 pr-0"></em> {{implRef.exception.errorMessage}}</p>
            }
            @if (this.implRef.invalidPassPhraseCounter > 0 && this.implRef.invalidPassPhraseCounter != 4) {
              <p class="attemptCont"> {{this.implRef.invalidPassPhraseCounter}} attempt(s) remaining. </p>
            }
            @if (this.implRef.invalidPassPhraseCounter == 0) {
              <p class="attemptCont">You have exceeded maximum number of attempts. Please try again after {{this.universalService.lockTimer}} minutes.</p>
            }
          </div>
        }
        @if (this.implRef.isPassPhraseLoginError && this.implRef.invalidPassPhraseCounter == 1 ) {
          <div class="error-msg">
            <p class="attemptCont"><em class="NeueAlert mr-1 pr-0"></em> {{this.implRef.invalidPassPhraseCounter}} attempt remaining. </p>
            <p class="passPhraseErrorCont"> {{implRef.exception.errorMessage}}</p>
          </div>
        }
      </div>

      <!-- button -->
      <div class="btn-wrap mt-4 mb-3 mb-md-5">
        <button class="btn btn-submit" (click)="validate2FA(Passphrase.value)" aria-label="Submit button" [disabled]="!this.implRef.enablePassPhraseSubmitButton">Submit</button>
        <a href="javascript:void(0);" rel="noopener noreferrer" (click)="forgotPassPhrase()" class="txt-forgot-pssphrase">Forgot passphrase?</a>
      </div>

    </div>

    <!-- Modal footer -->
    <div class="modal-footer border-0">
      <div class="user-note">
        <p>Please make sure all the devices from where you access JioAICloud are on the latest version.</p>
      </div>
    </div>

  </div>
</div>
</div>